/* ============================================================
   Offe Market - arrows for the scrolling spotlight row.
   Styles and notes: assets/custom-spotlight-scroll.css.

   Adds prev/next buttons to every spotlight section in the GRID
   layout. Each one is hidden when there is nothing further to
   scroll to that way, and both are hidden when every tile already
   fits. The row still scrolls by swipe, trackpad and keyboard
   without them.

   Also keeps the card text sticky while the page scrolls, which
   native position: sticky can't do inside a sideways-scrolling row,
   and on touch screens plays the hover effects as things scroll
   into the middle of the screen and restores the fixed gradient
   backgrounds phones would otherwise drop.
   ============================================================ */

(function () {
  var ICON =
    '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false">' +
    '<path d="M6 3l5 5-5 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function makeButton(dir) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'spotlight-scroll__arrow spotlight-scroll__arrow--' + dir;
    b.setAttribute('aria-label', dir === 'prev' ? 'Scroll back' : 'Scroll forward');
    b.innerHTML = ICON;
    if (dir === 'prev') b.firstChild.style.transform = 'rotate(180deg)';
    b.hidden = true;
    return b;
  }

  function init(scope) {
    var rails = (scope || document).querySelectorAll('.spotlight-cards__blocks--grid');
    rails.forEach(function (rail) {
      if (rail.dataset.spotScroll) return;
      rail.dataset.spotScroll = '1';

      var host = rail.parentElement;
      var prev = makeButton('prev');
      var next = makeButton('next');
      host.appendChild(prev);
      host.appendChild(next);

      var rtl = getComputedStyle(rail).direction === 'rtl';

      function update() {
        var max = rail.scrollWidth - rail.clientWidth;
        var pos = Math.abs(rail.scrollLeft);
        prev.hidden = max <= 2 || pos <= 2;
        next.hidden = max <= 2 || pos >= max - 2;
      }

      function step(sign) {
        // one card's width plus the space beside it
        var items = rail.querySelectorAll('.spotlight-cards__item');
        var w = items.length > 1
          ? Math.abs(items[1].offsetLeft - items[0].offsetLeft)
          : rail.clientWidth;
        var count = Math.max(1, Math.floor(rail.clientWidth / w));
        rail.scrollBy({ left: sign * (rtl ? -1 : 1) * w * count, behavior: 'smooth' });
      }

      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
      rail.addEventListener('scroll', update, { passive: true });
      if (window.ResizeObserver) new ResizeObserver(update).observe(rail);
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Sticky text (see the CSS file) ---------- */

  function headerOffset() {
    var h = document.querySelector('.shopify-section-header');
    if (!h) return 0;
    var pos = getComputedStyle(h).position;
    if (pos !== 'sticky' && pos !== 'fixed') return 0;
    return Math.max(0, h.getBoundingClientRect().bottom);
  }

  var ticking = false;

  function placeStickyText() {
    ticking = false;
    var wrappers = document.querySelectorAll('.spotlight-cards__blocks--grid .info--sticky');
    if (!wrappers.length) return;
    var top = headerOffset();
    wrappers.forEach(function (w) {
      var item = w.parentElement;
      var base = item.getBoundingClientRect().top + w.offsetTop;
      var room = item.clientHeight - w.offsetHeight - w.offsetTop;
      var y = Math.min(Math.max(top - base, 0), Math.max(room, 0));
      w.style.transform = y ? 'translateY(' + Math.round(y) + 'px)' : '';
    });
  }

  function requestPlace() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(placeStickyText);
  }

  window.addEventListener('scroll', requestPlace, { passive: true });
  window.addEventListener('resize', requestPlace);

  /* ---------- Touch screens: hover effects play on scroll ----------
     Phones can't hover, so:
     - a spotlight tile or category card gets .is-shape-active while
       it is in the middle band of the screen (its centre between
       20% and 80% of the height) AND at least 75% swiped into view
       in its sideways row;
     - in each collection list, the one row nearest the middle of
       the screen (centre between 30% and 70%) gets .is-hover-active.
     The rules that play the hover state for those classes are at
     the end of assets/custom-spotlight-morph.css, and carry their
     own reduced-motion gates. Off on mouse/trackpad screens, which
     have real hover. */

  var SHAPE_TARGETS = '.spotlight-cards__item, .category-row__card';
  var touchShapes = !window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var shapeTicking = false;

  function updateShapes() {
    shapeTicking = false;
    var vh = window.innerHeight;
    var vw = window.innerWidth;
    document.querySelectorAll(SHAPE_TARGETS).forEach(function (el) {
      var r = el.getBoundingClientRect();
      var cy = r.top + r.height / 2;
      var left = 0;
      var right = vw;
      var row = el.closest('.spotlight-cards__blocks--grid, .category-row__rail');
      if (row) {
        var rr = row.getBoundingClientRect();
        left = Math.max(left, rr.left);
        right = Math.min(right, rr.right);
      }
      var seen = Math.min(r.right, right) - Math.max(r.left, left);
      var on = r.width > 0 && cy > vh * 0.2 && cy < vh * 0.8 && seen >= r.width * 0.75;
      el.classList.toggle('is-shape-active', on);
    });

    document.querySelectorAll('.collections-list__content').forEach(function (list) {
      var rows = list.querySelectorAll('.collections-list__item');
      var best = null;
      var bestDist = Infinity;
      rows.forEach(function (row) {
        var r = row.getBoundingClientRect();
        var cy = r.top + r.height / 2;
        var dist = Math.abs(cy - vh / 2);
        if (cy > vh * 0.3 && cy < vh * 0.7 && dist < bestDist) {
          best = row;
          bestDist = dist;
        }
      });
      rows.forEach(function (row) {
        row.classList.toggle('is-hover-active', row === best);
      });
    });
  }

  /* ---------- Phones: scrolling gradient backgrounds ----------
     Tags sections whose colour scheme paints a gradient with
     background-attachment: fixed, which phones ignore. The CSS
     at the end of assets/custom-spotlight-scroll.css rebuilds the
     effect for them. Touch screens only. */

  function tagFixedGradients(scope) {
    if (!touchShapes) return;
    (scope || document).querySelectorAll('.background').forEach(function (el) {
      var cs = getComputedStyle(el);
      if (cs.backgroundAttachment.indexOf('fixed') > -1 && cs.backgroundImage.indexOf('gradient') > -1) {
        el.classList.add('has-fixed-gradient');
      }
    });
  }

  function requestShapes() {
    if (!touchShapes || shapeTicking) return;
    shapeTicking = true;
    requestAnimationFrame(updateShapes);
  }

  // capture: also hears the sideways scroll inside each row
  document.addEventListener('scroll', requestShapes, { passive: true, capture: true });
  window.addEventListener('resize', requestShapes);
  window.addEventListener('load', requestShapes);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      tagFixedGradients();
    });
  } else {
    init();
    tagFixedGradients();
  }
  requestPlace();
  requestShapes();

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
    tagFixedGradients(e.target);
    requestPlace();
    requestShapes();
  });
})();

/* ============================================================
   Offe Market - shoe photos clear of the card info panel
   (added to this file because it already loads on every page)

   On product cards tagged CATEGORY:Shoes (class product-card--shoe,
   set in snippets/product-card.liquid), the info panel overlays the
   bottom of the photo and often hides the shoe. For a photo shot on a
   plain backdrop, this fits the photo into the space ABOVE the panel
   and fills the strip behind the panel with the photo's own backdrop
   color (sampled from its edges), so the shoe sits centred in the
   visible area.

     cover   - photo fills the space above the panel (shoe stays big).
               Used when that crop keeps the whole shoe in view.
     contain - whole photo shrunk into that space, when cover would cut
               the shoe off.

   Lifestyle photos (edges not a plain backdrop) are left as they are.
   The 1st photo and the hover (2nd) photo are handled separately.
   Styles: assets/custom.css, "SHOE PHOTOS CLEAR OF THE INFO PANEL".
   ============================================================ */
(function () {
  var GRID = 48;          // photo is sampled on a GRID x GRID canvas
  var EDGE_TOLERANCE = 14; // max edge-pixel difference from the backdrop, 0-255
  var SUBJECT_DIFF = 32;   // a pixel this different from the backdrop is "shoe"
  var SAFE_MARGIN = 0.02;  // keep this much of the photo around the shoe when cropping

  function analyse(img) {
    try {
      var c = document.createElement('canvas');
      c.width = c.height = GRID;
      var ctx = c.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(img, 0, 0, GRID, GRID);
      var d = ctx.getImageData(0, 0, GRID, GRID).data;
      var n = GRID, lowest = Math.round(n * 0.6), i, k;

      // backdrop = top row + left/right edges down to 60% of the height
      // (the bottom edge is often cropped through the shoe, so skipped)
      var pts = [];
      for (i = 0; i < n; i++) pts.push(i);
      for (i = 1; i < lowest; i++) { pts.push(i * n); pts.push(i * n + n - 1); }
      var avg = [0, 0, 0];
      pts.forEach(function (p) { for (k = 0; k < 3; k++) avg[k] += d[p * 4 + k]; });
      avg = avg.map(function (s) { return s / pts.length; });
      var worst = 0;
      pts.forEach(function (p) {
        for (k = 0; k < 3; k++) worst = Math.max(worst, Math.abs(d[p * 4 + k] - avg[k]));
      });
      if (worst > EDGE_TOLERANCE) return null;

      // where the shoe is: bounding box of pixels unlike the backdrop
      var x0 = n, y0 = n, x1 = -1, y1 = -1;
      for (var y = 0; y < n; y++) {
        for (var x = 0; x < n; x++) {
          var p = (y * n + x) * 4, diff = 0;
          for (k = 0; k < 3; k++) diff = Math.max(diff, Math.abs(d[p + k] - avg[k]));
          if (diff > SUBJECT_DIFF) {
            if (x < x0) x0 = x; if (x > x1) x1 = x;
            if (y < y0) y0 = y; if (y > y1) y1 = y;
          }
        }
      }
      if (x1 < 0) { x0 = 0; y0 = 0; x1 = n - 1; y1 = n - 1; }
      return {
        bg: 'rgb(' + avg.map(Math.round).join(',') + ')',
        box: [x0 / n, y0 / n, (x1 + 1) / n, (y1 + 1) / n]
      };
    } catch (e) {
      return null; // photo from another domain can't be read - leave it
    }
  }

  function infoSpace(card) {
    var media = card.querySelector('.product-card__media');
    var info = card.querySelector('.product-card__information');
    if (!media || !info) return 0;
    var m = media.getBoundingClientRect();
    var top = info.getBoundingClientRect().top;
    return top < m.bottom ? Math.max(0, Math.round(m.bottom - top)) : 0;
  }

  // pick cover or contain for one photo, from the space above the panel
  function layout(img, card) {
    var a = img._studio;
    if (!a || !img.naturalWidth) return;
    var media = card.querySelector('.product-card__media');
    var w = media.clientWidth;
    var h = media.clientHeight - (parseFloat(card.style.getPropertyValue('--card-info-space')) || 0);
    if (w <= 0 || h <= 0) return;
    var iw = img.naturalWidth, ih = img.naturalHeight;
    var s = Math.max(w / iw, h / ih);           // cover scale
    var fw = w / (iw * s), fh = h / (ih * s);   // visible share of the photo
    var b = a.box;
    var fits =
      b[0] >= 0.5 - fw / 2 + SAFE_MARGIN && b[2] <= 0.5 + fw / 2 - SAFE_MARGIN &&
      b[1] >= 0.5 - fh / 2 + SAFE_MARGIN && b[3] <= 0.5 + fh / 2 - SAFE_MARGIN;
    img.classList.toggle('is-studio--contain', !fits);
  }

  function checkImage(img, card) {
    if (!img.naturalWidth) return;
    var a = analyse(img);
    img._studio = a;
    img.classList.toggle('is-studio', !!a);
    if (!a) {
      img.classList.remove('is-studio--contain');
      return;
    }
    img.style.setProperty('--studio-bg', a.bg);
    layout(img, card);
  }

  function measure(card) {
    // the panel grows on hover (sizes, add to cart) - measure it at rest
    if (card.matches(':hover, :focus-within')) return;
    card.style.setProperty('--card-info-space', infoSpace(card) + 'px');
    card.querySelectorAll('.product-card__media img.is-studio').forEach(function (img) {
      layout(img, card);
    });
  }

  var resizeObs = window.ResizeObserver
    ? new ResizeObserver(function (entries) {
        entries.forEach(function (e) { measure(e.target); });
      })
    : null;

  function init(scope) {
    (scope || document).querySelectorAll('product-card.product-card--shoe').forEach(function (card) {
      if (card.dataset.studioInit) return;
      card.dataset.studioInit = '1';
      measure(card);
      if (resizeObs) resizeObs.observe(card);
      card.querySelectorAll('.product-card__media img').forEach(function (img) {
        // left on, so a colour swap that changes the photo is re-checked
        img.addEventListener('load', function () { checkImage(img, card); });
        if (img.complete) checkImage(img, card);
      });
    });
  }

  function start() {
    init();
    // cards added later: filters, load more, sections re-rendered
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; init(); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
